export const TYPOGRAPHY_ROLE_LABELS = Object.freeze({
  display: "Заголовки",
  body: "Основной текст",
  accent: "Акцентный стиль",
});

export const fontStack = (role) => {
  const quoted = `"${role.family}"`;
  const fallbacks = (role.fallback_stack || []).join(", ");
  return `${quoted}${fallbacks ? `, ${fallbacks}` : ""}`;
};

export const licenseLabel = (role) =>
  role.license_status === "verified_ofl" ? "Можно использовать" : "Нужно проверить лицензию";

const naturalRoleName = (match, replacement) =>
  match[0] === match[0].toUpperCase()
    ? replacement[0].toUpperCase() + replacement.slice(1)
    : replacement;

export const normalizeTypographyExplanation = (value = "") =>
  String(value)
    .replace(/display[\s‐‑‒–—-]*шрифт/giu, (match) => naturalRoleName(match, "шрифт для заголовков"))
    .replace(/body[\s‐‑‒–—-]*шрифт/giu, (match) => naturalRoleName(match, "шрифт для основного текста"))
    .replace(
      "Держать шрифт для заголовков только в точках внимания: обложки, hero-блоки, ключевые цитаты.",
      "Держать шрифт для заголовков только в точках внимания: обложки, ключевые блоки, выразительные цитаты.",
    );

export const typographyVersions = (state) =>
  (state.module_versions || [])
    .filter((item) => item.module_type === "typography-system")
    .sort((a, b) => b.version_number - a.version_number);
